<template>
    <div>
      <Widget>
        <TaskTableHeader
            :title="getTitle"
            :search="search"
            :chooseAll="chooseAll"
            :chooseNone="chooseNone"
            :deleteMsg="deleteMsg"
          />
        
        <v-client-table :data="dataToDisplay" :columns="columnsDatatable" :options="optionsDatatable">
          <!--
          <div slot="h__id">
            <input
                type="checkbox"
                @click="isMainChecked ? chooseNone() : chooseAll()"
                :checked="isMainChecked"
              />
          </div>
          -->
          <div slot="h__id"></div>
          <div slot="h__overdue"></div>
          <div slot="h__DueDate">Due Date</div>
          <div slot="h__Title"></div>
          <div slot="h__Attachments"></div>
          <div slot="h__Comments"></div>
          <div slot="h__Delete"></div>
          
          <div slot="id" slot-scope="props">
            <b-form-group class="abc-checkbox abc-checkbox-success">
              <input
                type="checkbox"
                class="custom-control-input" 
                :id="`checkbox${props.row.id}`" 
                :checked="isTaskChecked(props.row.id)"
                @click="changeChoosed(props.row.id)" 
                :disabled="isTaskChecked(props.row.id)"/>
              <label :for="`checkbox${props.row.id}`"></label>
            </b-form-group>
          </div>

          <div slot="overdue" slot-scope="props" title="Overdue task">
            <span v-if="isOverdue(props.row.DueDate)">
              <i :class="`fa fa-circle text-danger`" />
            </span>
          </div>

          <div slot="Title" slot-scope="props">
            <!--
            <b-form-input v-if="clickResult === 'dblclick' && clickedId === props.row.id" type="text" ref="tasks" :id="'task-'+props.row.id" v-model="props.row.Title" @change="doOnChange()" @blur="doOnBlur()"/>
            <a v-else slot="Title" slot-scope="props" @click="oneClick($event, props.row.id)">{{props.row.Title}}</a>
            -->
              
             <at v-if="clickResult === 'dblclick' && clickedId === props.row.id" at="@" :members="getPeople" v-model="props.row.Title" name-key="_atname" :suffix="suffix" :hideOnBlur="hideOnBlur">
                <template slot="item" slot-scope="s">
                      <img v-if="s.item._atimage" :src="s.item._atimage">
                      <span>&nbsp;&nbsp;</span>
                      <span v-text="s.item._atname"></span>
                </template>

                <span slot="embeddedItem" slot-scope="s">
                    <span class="tag">
                      <a :href="s.current._aturl">{{ s.current._atname }}</a>
                      <!-- <a v-if="s.current.CreatedByEmpID" :href="s.current.CreatedByEmpID">{{ s.current.AssetTitle }}</a> -->
                    </span>
                </span>

                <at at="#" :members="getDocs" v-model="props.row.Title" name-key="_atname" :suffix="suffix" :hideOnBlur="hideOnBlur">
                <template slot="item" slot-scope="s">
                      <img v-if="s.item._atimage" :src="s.item._atimage">
                      <i v-if="s.item.AssetType" :class="getIcon(s.item.AssetType)"/>
                      <span>&nbsp;&nbsp;</span>
                      <span v-text="s.item._atname"></span>
                </template>

                <span slot="embeddedItem" slot-scope="s">
                    <span class="tag">
                      <a :href="s.current._aturl">{{ s.current._atname }}</a>
                      <!-- <a v-if="s.current.CreatedByEmpID" :href="s.current.CreatedByEmpID">{{ s.current.AssetTitle }}</a> -->
                    </span>
                </span>
                  
                <div 
                    v-click-outside="vcoConfig"
                    contenteditable 
                    placeholder=""
                    class="editor"
                    :ref="'task'+props.row.id" 
                    :id="props.row.id"
                    @keyup.esc="keyMonitor" tabindex="0"
                    >
                  </div>
              </at>
            </at>

            <a v-else slot="Title" slot-scope="props" @click="oneClick($event, props.row.id)" v-html="props.row.Title"></a>

          </div>

          <div slot="DueDate" slot-scope="props">
            <DatePicker 
                :id="'date-'+props.row.id"
                :value="props.row.DueDate" 
                lang="en" 
                format="MM-DD-YYYY" 
                :not-before="notBefore" 
                placeholder="Select a Date" 
                input-class="form-control"
                @change="updateTaskDueDate(props.row.id,$event)"
                :disabled="isTaskChecked(props.row.id)"
                append-to-body>
              <i class="glyphicon glyphicon-th" slot="calendar-icon" />
            </DatePicker>
          </div>

          <div slot="Attachments" slot-scope="props">
            <i v-show="props.row.HasAssets" class="fa fa-paperclip" />
          </div>
          <div slot="Comments" slot-scope="props">
            <i v-show="props.row.HasComments" class="fa fa-comments-o"></i>
          </div>
          
          <a slot="Delete" v-if="!isTaskChecked(props.row.id)" slot-scope="props" class="fa fa-trash" @click="showSureModal(props.row.id)"></a>
          
        </v-client-table>

        <!--
        <b-card v-show="this.loaded && dataToDisplay.length === 0" class="mb-xlg border-0">
          <a href="#" class="fw-semi-bold text-success">Hurray! </a>
          <hr />
          <div class="mb-lg">
            No tasks here!
          </div>
        </b-card>
        -->

      </Widget>

      <b-modal id="sure" ref="sure-modal" size="sm" body-class="bg-white" title="Are you sure?" @ok="removeTask" @cancel="hideSureModal">
            Are you sure you want to delete this task?
      </b-modal>
  </div>
</template>

<script>
 /* eslint-disable */

import Vue from 'vue';

import Widget from '@/components/Widget/Widget';
import TaskTableHeader from '../TaskTableHeader/TaskTableHeader';
import At from 'vue-at';
import DatePicker from 'vue2-datepicker';
import { mapState, mapActions, mapMutations } from 'vuex';
import vClickOutside from 'v-click-outside';
import moment from 'moment';


export default {
  name: 'BaseTable',
  directives: {
      clickOutside: vClickOutside.directive
  },
  components: {
    Widget, TaskTableHeader, DatePicker, At
  },
  //props: ['visible', 'filter', 'openedTask', 'openTask', 'composeData', 'changeCompose', 'compose'],
  props: ['filter', 'passedTasks'],
  data() {
    return {
      selectedTaskID: 0,
      text: '',
      hideOnBlur: true,
      suffix: ' ',
      notBefore: new Date(),
      vcoConfig: {
        handler: this.handler,
        middleware: this.middleware,
        //events: ['dblclick', 'click']
        events: ['click']
      },
      firstClick: false,
      delay: 300,
      clicks: 0,
      timer: null,
      clickResult: '',  // one click or double click?
      clickedId: 0,
      checkedIds: [],
      columnsDatatable: ['id', 'overdue', 'Title', 'DueDate', 'Attachments', 'Comments', 'Delete'],
      optionsDatatable: {
        perPage: 5,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { Title: 'w-75 p-3', DueDate: 'width-100'},
        skin: 'table',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
        sortable: [],
        rowClassCallback: function(row) {
          return row.Status === 'NEEDS_REVIEW' ? 'needsReviewTask' : '';
        }
      },
    };
  },
  
  /*
  async created() {
    if(!this.passedTasks)
      await this.init();
    else
      this.setTasks(this.passedTasks);
    if(this.isEmpty(this.settings)) {
      //console.log('getting settings from API');
      this.getSites({ customerID: this.customerID});
    }
  },
  */

  methods: {
    ...mapActions('tasks', ['getTasks', 'updateTask', 'deleteTask']),
    ...mapActions('alert', ['setLoading', 'setDismissSuccessCountDown']),
    ...mapActions('customer', ['getSites']),
    ...mapMutations('tasks', ['setTasks']),

    async init() {
      await this.getTasks({ employeeID: this.userID });
    },

    isEmpty(obj) {
      for(var key in obj) {
          if(obj.hasOwnProperty(key))
              return false;
      }
      return true;
    },

    handler (event, el) { // eslint-disable-line
        //console.log('Clicked outside (Using config), middleware returned true :)')  // eslint-disable-line 
        //this.$nextTick(() => console.log(this.$refs.tasks.$el));  // eslint-disable-line  
        //console.log(el);// eslint-disable-line 
        this.updateTaskTitle(el.getAttribute("id"), el.innerHTML);
        this.clickResult = '';
    },
    // Note: The middleware will be executed if the event was fired outside the element.
    //       It should have only sync functionality and it should return a boolean to
    //       define if the handler should be fire or not
    middleware (event, el) { // eslint-disable-line
      //console.log('In middleware,' + JSON.stringify(el));// eslint-disable-line
      //console.log('In middleware,' + window.getComputedStyle(el, null).getPropertyValue('display'));// eslint-disable-line
      // basically let the event fire if this is 2nd click
      if (this.firstClick === true) {
        this.firstClick = false;  // reset when they click outside
        return true;
      } else {
        this.firstClick = true;
        return false;
      }
      
    },

    keyMonitor(event) {
      console.log(event.key);
      console.log('the id of the input was:' + event.target.id);
      switch(event.key) {
        case 'Enter'  : console.log("enter key was pressed!"); break;
        case 'Escape' : console.log("escape key was pressed!"); this.clickResult = ''; this.firstClick = false; break;
        default: console.log("Key not recognized!"); break;
      }
      
    },

    showSureModal(id) {
      console.log('id passed:' + id); //eslint-disable-line
      this.selectedTaskID = id;
      this.$refs['sure-modal'].show();
    },

    hideSureModal() {
      this.$refs['sure-modal'].hide();
    },

    updateTaskStatus(taskID, status, statusID) {
      let taskToUpdate = {
        taskID : taskID,
        task : {
          Status : status,
          StatusID: statusID
        }
      };

      console.log('Updating task:' + JSON.stringify(taskToUpdate)); //eslint-disable-line
      this.updateTask(taskToUpdate);
    },

    updateTaskDueDate(taskID, dueDate) {
      console.log('Date:' + dueDate + ', Moment:' + moment(dueDate).format('MM/DD/YYYY')); //eslint-disable-line   
      this.passedTasks.find(m => m.id === taskID).DueDate = dueDate && moment(dueDate).format('MM/DD/YYYY');   
      if(!dueDate)
        return;

      let taskToUpdate = {
        taskID : taskID,
        task : {
          DueDate : dueDate,
        }
      };

      console.log('Updating task:' + JSON.stringify(taskToUpdate)); //eslint-disable-line
      this.updateTask(taskToUpdate);
    },

    updateTaskTitle(taskID, desc) {
      let employeeID;
      let employeeName;
      let userID = 1;

      /* eslint-disable */
      console.log('Add task called with task=' + desc);
      let removeHtml = desc.replace(/<\/?[^>]+(>|$)/g, "");
      //console.log('removeHtml:' + removeHtml);
      let trimmedText = removeHtml.replace(/\s{2}/g, ' ');
      console.log('TrimmedText:' + trimmedText);

      let regexp = /<a .*?href=\"(.+)\">(.+)<.a>/ig;
      let regexp1 = /\/profile\/(.+)/i;

      let match = regexp.exec(desc); // match[0] = <a href="/">Linda Davis</a>   match[1]= /profile/2    match[2]= Linda Davis

      while (match != null) {
        console.log('match[0]:' + match[0] + ', match[1]=' + match[1] + ', match[2]=' + match[2]);
        let result = match[1].match(regexp1);
        if (result != null) {
          employeeID = result[1];
          employeeName = match[2];
          console.log('EmployeeID:' + employeeID);
          console.log('EmployeeName:' + employeeName);
        } else {
          let assetUrl = match[1];
          let assetName = match[2];
          console.log('Asset Url:' + assetUrl + ', Asset Name:' + assetName);
        }        
        match = regexp.exec(desc);
      }

      let taskToUpdate = {
        'taskID'            : taskID,
        'task' : {
          'AssignedToEmpID' : employeeID,
          'CreatedByEmpID'  : this.userID,
          'Title'           : desc,
          'Status'          : 'INCOMPLETE',
          'TaskType'        : 'YOUR_TASKS'
        }
      };

      console.log('Updating task:' + JSON.stringify(taskToUpdate));
      this.updateTask(taskToUpdate);
    },

    getIcon(type) {
      let iconClass = '';
      switch(type) {
        case 'XLS'    : iconClass='fa fa-file-excel-o'; break;
        case 'DOC'    : iconClass='fa fa-file-word-o'; break;
        case 'PDF'    : iconClass='fa fa-file-pdf-o'; break;
        case 'PPT'    : iconClass='fa fa-file-powerpoint-o'; break;
        default       : iconClass='fa fa-file'; break;
      }
      return iconClass;
    },

    oneClick(event, id){
      this.clickedId = id;
      this.clicks++ 
      if(this.clicks === 1) {
        var self = this
        this.timer = setTimeout(function() {
          self.clickResult = event.type;
          self.view(id);
          self.clicks = 0
        }, this.delay);
        
      } else{
          clearTimeout(this.timer);
          this.clickResult = 'dblclick';
          this.clicks = 0;
          this.edit(id);
          let temp = 'task' + id;
          //this.$nextTick(() => this.$refs['task'+id].focus());
          this.$nextTick(() => this.placeCaretAtEnd(this.$refs['task'+id]));
          //this.$nextTick(() => console.log(window.getComputedStyle(this.$refs.tasks, null).getPropertyValue('display'))) // eslint-disable-line
      }
    },

    // https://stackoverflow.com/questions/4233265/contenteditable-set-caret-at-the-end-of-the-text-cross-browser
    placeCaretAtEnd(el) {
      el.focus();
      if (typeof window.getSelection != "undefined"
              && typeof document.createRange != "undefined") {
          var range = document.createRange();
          range.selectNodeContents(el);
          range.collapse(false);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
          var textRange = document.body.createTextRange();
          textRange.moveToElementText(el);
          textRange.collapse(false);
          textRange.select();
      }
    },

    doOnChange() {
      console.log('onchange called'); //eslint-disable-line
      this.clickResult = '';
    },

    doOnBlur() {
      console.log('onblur called'); //eslint-disable-line
      this.clickResult = '';
    },

    view(taskID) {
      this.$router.push({
        name: 'Task',
        params: {
          taskID: taskID,
          task: this.passedTasks.find(m => m.id === taskID)
        }
      })
    },

    edit(id) {
      // eslint-disable-next-line
      console.log('Edit was clicked with id:' + id);
    },

    removeTask() {
      // eslint-disable-next-line
      console.log('Need to delete task with id:' + this.selectedTaskID);
      this.deleteTask(this.selectedTaskID);
    },
    
    changeChoosed(id) {
      let checked = event.target.checked;

      if (checked)
        this.updateTaskStatus(id, 'NEEDS_REVIEW', 2);
      else
        this.updateTaskStatus(id, 'INCOMPLETE', 1);
    },

    isTaskChecked(id) {
      let t = this.passedTasks.filter(task => task.id === id);
      return t[0].Status === 'NEEDS_REVIEW';
    },

    chooseAll() {
      this.chooseNone();

      const { passedTasks, filter, checkedIds } = this;

      if (filter) {
        if (this.filter === 'INCOMPLETE')
          passedTasks.filter(task => task.Status === this.filter).forEach(task => checkedIds.push(task.id));
        else
          passedTasks.filter(task => task.TaskType === this.filter  && task.Status !== 'COMPLETED').forEach(task => checkedIds.push(task.id));
      } else {
        passedTasks.forEach(task => checkedIds.push(task.id));
      }
    },

    chooseNone() {
      this.checkedIds = [];
    },

    deleteMsg() {
      this.passedTasks = this.passedTasks.filter(m => this.checkedIds.indexOf(m.id) === -1);
      this.chooseNone();
    },

    handleOpenTask(id) {
      this.passedTasks.find(m => m.id === id).unreaded = false;
      this.openTask(id);
    },

    search(value) {
      Vue.set(this, 'searchString', value.toLowerCase());
    },

    _searchable(m) {
      if (this.searchString) {
        return (m.content.toLowerCase().indexOf(this.searchString) !== -1
          || m.from.toLowerCase().indexOf(this.searchString) !== -1
          || m.theme.toLowerCase().indexOf(this.searchString) !== -1);
      }

      return true;
    },

    isOverdue(d) {
      return moment(d).tz(this.settings.Timezone).isBefore(moment().tz(this.settings.Timezone), 'day'); 
    }
  },
  computed: {

    ...mapState({
        loading: state => state.alert.loading,
        loaded: state => state.alert.loaded,
        errored: state => state.alert.errored,
        alertMessage: state => state.alert.message,
        //tasks: state => state.tasks.tasks,
        assets: state => state.tasks.assets,
        customerAssets: state => state.customer.assets,
        employees: state => state.customer.employees,
        userID: state => state.customer.userID,
        customerID: state => state.customer.customerID,
        settings: state => state.customer.settings,
    }),

    filteredTasks() {
      if (this.filter === 'INCOMPLETE')
        return this.passedTasks.filter(task => task.Status === this.filter);
      else
        return this.passedTasks.filter(task => task.TaskType === this.filter  && task.Status !== 'COMPLETED');
    },

    dataToDisplay() {
      //return this.filter ? this.filteredTasks : this.tasks;
      return this.passedTasks.filter(task => task.TaskType === 'YOUR_TASKS' && moment(task.DueDate).tz(this.settings.Timezone).diff(moment().tz(this.settings.Timezone)) < 0);
    },

    isMainChecked() {
      return this.dataToDisplay.length === this.checkedIds.length;
    },

    getTitle() {
      let title;
      switch(this.filter) {
        case 'INCOMPLETE' : title = 'Carried Over Incomplete Tasks'; break;
        case 'DAILY_ROUTINE' : title = 'Daily Routine Tasks'; break;
        case 'MONTHLY_ROUTINE' : title = 'Monthly Routine Tasks'; break;
        case 'MISSED_CALL' : title ='Missed Calls'; break;
        default: title = 'Your Tasks'; break;
      }
      return title;
    },

    getPeople() {
      this.employees.forEach(t => {
        t._atname = t.EmployeeName,
        t._atimage = 'https://randomuser.me/api/portraits/men/2.jpg'
        t._aturl = `/app/profile/${t.EmployeeID}`
      });
      return this.employees;
    },

    getDocs() {
      this.customerAssets.forEach(t => {
        t._atname = t.AssetTitle,
        t._atimage = '',
        t._aturl = t.AssetUrl
      });
      return this.customerAssets;
    },

  },

  watch: {
    filter(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.chooseNone();
      }
    },
  },
};
</script>

<style src="./BaseTable.scss" lang="scss" scoped/>
